<script setup>
import { get_product_json,fileopen_json } from '/src/api/product/product.js'
import { webSocket } from './api/websocket'
import { nextTick, provide, ref,getCurrentInstance } from 'vue';
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { set, remove, get } from './utils/Cache';
const router = useRouter();
const { proxy } = getCurrentInstance();
const store = useStore();
const version = '2026_01_21'
set('version',version)

if (!JSON.parse(get('setTimeZone'))) {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const getUTCOffset = (timeZone) =>{
    console.log("timeZone",timeZone);
    
    const now = new Date();
    // 使用 Intl.DateTimeFormat 获取指定时区的时间
    const options = { timeZone, timeZoneName: 'short' };
    const formatter = new Intl.DateTimeFormat('en-US', options);
    const parts = formatter.formatToParts(now);
    
    // 从 formatted parts 提取 UTC 偏移量
    const timeZonePart = parts.find(part => part.type === 'timeZoneName');
    console.log("timeZonePart",timeZonePart);

    return timeZonePart ? timeZonePart.value.replace("GMT", "UTC") : 'UTC';
  }
  const timeZoneValue = getUTCOffset(timeZone)
  set('timeZone',timeZoneValue) 
}
let timeoutId = ref(null)
// 开始计时器
const startTimeout = () => {
  // console.log('timeoutId',timeoutId.value);
  timeoutId.value = setTimeout(() => {
    // 在用户两个小时没有操作后执行退出逻辑
    logout();
  }, 2 * 60 * 60 * 1000); // 3分钟 = 3 * 60 * 1000 毫秒
  // }, 30 * 1000); // 3分钟 = 3 * 60 * 1000 毫秒

};

// 重置计时器
const resetTimeout = () => {
  clearTimeout(timeoutId.value);
  startTimeout();
};

// 退出登录逻辑
const logout = async () => {
  // 在这里执行退出登录的逻辑，例如跳转到登录页面
  // 使用路由或其他方式
  // 例如：router.push('/login');
  const res = await proxy.$api.logOut();
  console.log('handleLoginOut',res);
  if (res === null) {
    const items = {};
    items.locale = localStorage.getItem('locale');
    localStorage.clear();
    for (let key in items) {
      localStorage.setItem(key, items[key]);
    }
    router.push({
      name: "login"
    })
  }

};
// 监听用户的交互事件，例如鼠标移动或键盘输入
document.addEventListener('mousemove', resetTimeout);
document.addEventListener('keydown', resetTimeout);


startTimeout()

// 检测浏览器刷新
const handleRefresh = () => {
  console.log('handleRefresh',"刷新界面");

  const token = JSON.parse(get('token'))
  console.log('token',token);
  if (token != null) {
    // var send_param = {}
    var send_param = {'cmd':'Authenticate'}
    webSocket(send_param, (result) => {
      console.log(result);
    });
  }
}


const getJsonConfig = () => {
  return new Promise(resolve => {
    const product_list = JSON.parse(get('product_list')) || []
    console.log('product_list',product_list);
    let check_config = []
    product_list.forEach(item => {
      console.log('item',item);
      if (JSON.parse(get(item))) {
        const version = JSON.parse(get(item)).version
        if (version) {
          check_config.push({"product_key":item,"version": version})
          console.log('check_config',check_config); 
        }
      }else{
        console.log(`${item}---不存在配置文件`);
      }
    });
    resolve(check_config)
  })
}

const handleConfig = () => {
  getJsonConfig().then(response => {
    const check_config = response
    if (check_config.length > 0) {
      proxy.$api.updateConfig(check_config).then(response => {
        console.log('updateConfig', response);
        if (response.length > 0) {
          console.log('update_pk', response);
          for (let i = 0; i < response.length; i++) {
            const product_key = response[i];
              fileopen_json(product_key).then(res =>{
                console.log('res',res);
                set(product_key, res)
              })
              get_product_json(product_key).then(res =>{
                console.log('res',res);
                set(product_key, res)
              })
          }
        }
      })
    } else {
      console.log('无需下载配置文件');
    }
  })
}
onMounted(() => {
  window.addEventListener('beforeunload', handleRefresh());
  handleConfig()
})
// 在组件销毁时清除计时器和事件监听
onBeforeUnmount(() => {
  clearTimeout(timeoutId.value);
  document.removeEventListener('mousemove', resetTimeout);
  document.removeEventListener('keydown', resetTimeout);
});
</script>

<template>
  <router-view></router-view>
</template>

<style>
#app {
  height: 100%;
}
* {
  margin: 0;
  padding: 0;
  list-style: none;
  box-sizing: border-box;
}

</style>
 